'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ShadowEffect: ()=>ShadowEffect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_ShadowEffect_variants_cjs_namespaceObject = require("./ShadowEffect.variants.cjs");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const ShadowEffect = ({ children, onOpen, onClose, shouldOpenOnFocus = true, shouldCloseOnBlur = true, ...props })=>{
    const [isOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(false);
    const child = external_react_default().Children.only(children);
    const { shadowEffectSlot, shadowEffectBackgroundSlot } = (0, external_ShadowEffect_variants_cjs_namespaceObject.shadowEffectVariants)({
        ...props,
        isOpen
    });
    function handleKeyDown(evt) {
        const key = evt.key;
        if ('Escape' === key) {
            evt.preventDefault();
            handleClose();
        }
    }
    function handleOpen() {
        if (!isOpen) {
            onOpen?.();
            setIsOpen(true);
        }
    }
    function handleClose() {
        setIsOpen(false);
        onClose?.();
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            isOpen && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("button", {
                className: shadowEffectBackgroundSlot(),
                onClick: handleClose
            }),
            /*#__PURE__*/ external_react_default().isValidElement(child) && /*#__PURE__*/ external_react_default().cloneElement(child, {
                className: shadowEffectSlot(),
                onClick: ()=>{
                    handleOpen();
                    child.props.onClick?.();
                },
                onFocus: ()=>{
                    if (shouldOpenOnFocus) handleOpen();
                    child.props.onFocus?.();
                },
                onBlur: ()=>{
                    if (shouldCloseOnBlur) handleClose();
                    child.props.onBlur?.();
                },
                onKeyDown: (evt)=>{
                    handleKeyDown(evt);
                    child.props.onKeyDown?.(evt);
                }
            })
        ]
    });
};
exports.ShadowEffect = __webpack_exports__.ShadowEffect;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ShadowEffect"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
